// src/scripts/testimonials-form.ts
import { createReview } from '../lib/api';

function qs<T extends HTMLElement>(sel: string) {
  return (typeof document !== 'undefined' ? document.querySelector(sel) : null) as T | null;
}

// --- TOAST Tailwind (verde éxito / rojo error) ---
function showToast(message: string, type: 'success' | 'error' = 'success') {
  const toast = qs<HTMLDivElement>('#toast');
  const text = qs<HTMLSpanElement>('#toast-text');
  if (!toast || !text) return;

  text.textContent = message;
  toast.classList.remove('hidden', 'opacity-0', 'translate-y-2', 'bg-green-600', 'bg-red-600');
  toast.classList.add(type === 'success' ? 'bg-green-600' : 'bg-red-600');

  requestAnimationFrame(() => {
    void toast.offsetWidth;
    toast.classList.add('transition-all', 'duration-300');
    toast.classList.remove('opacity-0', 'translate-y-2');
  });

  window.setTimeout(() => {
    toast.classList.add('opacity-0', 'translate-y-2');
    window.setTimeout(() => toast.classList.add('hidden'), 300);
  }, 2500);
}

function setupModalAndForm() {
  const openBtn = qs<HTMLButtonElement>('#open-testimonial-form');
  const closeBtn = qs<HTMLButtonElement>('#close-testimonial-form');
  const modal = qs<HTMLDivElement>('#testimonial-modal');
  const form = qs<HTMLFormElement>('#testimonial-form');
  const ratingStars = qs<HTMLDivElement>('#rating-stars');
  const ratingInput = qs<HTMLInputElement>('#testimonial-rating');

  if (!modal || !form) return;

  openBtn?.addEventListener('click', () => modal.classList.remove('hidden'));
  closeBtn?.addEventListener('click', () => modal.classList.add('hidden'));
  modal.addEventListener('click', (e) => { if (e.target === modal) modal.classList.add('hidden'); });

  // estrellas
  if (ratingStars && ratingInput) {
    const btns = Array.from(ratingStars.querySelectorAll<HTMLButtonElement>('.star-btn'));
    const paint = (idx: number) => btns.forEach((b, i) => b.querySelector('svg')?.classList.toggle('text-yellow-400', i <= idx));
    btns.forEach((btn, idx) => {
      btn.addEventListener('mouseenter', () => paint(idx));
      btn.addEventListener('mouseleave', () => paint(Number(ratingInput.value) - 1));
      btn.addEventListener('click', (e) => { e.preventDefault(); ratingInput.value = String(idx + 1); paint(idx); });
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const fd = new FormData(form);
    const author = String(fd.get('author') || '').trim();
    const role = String(fd.get('role') || '').trim();
    const company = String(fd.get('company') || '').trim();
    const quote = String(fd.get('quote') || '').trim();
    const rating = Number(fd.get('rating') || 0);

    if (!author || !quote) return showToast('Rellena nombre y comentario.', 'error');
    if (!rating || rating < 1 || rating > 5) return showToast('Selecciona una valoración (1–5).', 'error');

    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    const original = submitBtn?.textContent;
    submitBtn?.setAttribute('disabled', 'true');
    if (submitBtn) submitBtn.textContent = 'Enviando…';

    const payload = {
      name: author,
      role: company ? `${role} — ${company}` : role,
      message: quote,
      rating
    };

    try {
      await createReview(payload); // ← usa BASE correcta en dev/prod
      showToast('¡Gracias! Tu testimonio se ha enviado.', 'success');

      form.reset();
      ratingStars?.querySelectorAll('svg').forEach(svg => svg.classList.remove('text-yellow-400'));
      modal.classList.add('hidden');

      document.dispatchEvent(new CustomEvent('reviews:refresh'));
    } catch (err) {
      console.error(err);
      showToast('No se pudo guardar. Intenta de nuevo.', 'error');
    } finally {
      submitBtn?.removeAttribute('disabled');
      if (submitBtn && original != null) submitBtn.textContent = original;
    }
  });
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  window.addEventListener('DOMContentLoaded', setupModalAndForm);
}
